import { __assign } from 'tslib';
import React, { forwardRef } from 'react';
import { BasePlate } from '../components/base-plate/Component.js';
import 'react-merge-refs';
import 'classnames';
import '../../../icon-button/esm';
import '../warning-a716d657.js';
import 'detect-browser';
import '@alfalab/hooks';
import '@alfalab/icons-glyph/ChevronDownMIcon';
import '@alfalab/icons-glyph/CrossMIcon';
import '../components/button-list/component.js';

var styles = {"bold":"plate__bold_1g1fh","description":"plate__description_1g1fh","footer":"plate__footer_1g1fh","rounded":"plate__rounded_1g1fh","shadow":"plate__shadow_1g1fh"};
require('./desktop.css');

var PlateDesktop = forwardRef(function (restProps, ref) { return (React.createElement(BasePlate, __assign({}, restProps, { styles: styles, ref: ref }))); });

export { PlateDesktop };
